import { useSelectionContext } from 'modules/customEvents/contexts';
import {
  FIELD_TABLE_COLUMNS_WITH_BULK_ACTIONS,
  USER_FIELDS_EMPTY_STATE_CONFIG,
} from 'modules/dataDictionary/constants';
import { useUserMappingsContext } from 'modules/dataDictionary/contexts';
import { useExportFields } from 'modules/dataDictionary/hooks';
import { useFieldTable } from 'modules/dataDictionary/hooks/useFieldTable';
import { FieldDataType, ModalAction } from 'modules/dataDictionary/types';
import { createGridLayout } from 'modules/dataDictionary/utils';
import { GenericDataType } from 'modules/domains';
import { AllowedActionMenuElements } from 'ui/actionMenu/types';
import { Export24 } from 'ui/icons';
import { useModalContext } from 'utils/contexts/modal';
import { Table, TableBody, TableHeader, TableRow } from '../Table';
import { TableActions } from '../Table/TableActions';
import { TablePagination } from '../Table/TablePagination';

export const USER_PROFILE_FIELDS_TEXT = {
  tabGroupTestId: 'user-profile-fields-tabs-group',
};

export const UserProfileFieldsContent = () => {
  const {
    isErrorUserMappings: isError,
    isLoadingUserMappings: isLoading,
    refetchUserMappings,
    userMappings: mappings,
  } = useUserMappingsContext();
  const { showModal } = useModalContext();
  const { exportFields } = useExportFields();
  const { selected, toggleSelection } = useSelectionContext();

  const { filteredMappings, objectMappingNames, paginatedMappings } = useFieldTable({ mappings });

  const onCreateNewField = (parentName?: string) =>
    showModal({ action: ModalAction.NEW_USER_FIELD, payload: { parentName } });

  const gridLayout = createGridLayout();

  return (
    <>
      <TableActions
        dataType={GenericDataType.User}
        fieldType={FieldDataType.User}
        onCreateNewField={onCreateNewField}
        overflowMenuOptions={[
          {
            as: AllowedActionMenuElements.Button,
            content: (
              <>
                <Export24 />
                <span>Export user fields summary to CSV</span>
              </>
            ),
            id: 'user-profile-fields-export',
            onClick: () => exportFields(filteredMappings, 'user-profile-field-summary'),
          },
        ]}
        refetchFields={refetchUserMappings}
      />
      <Table>
        <TableHeader
          fieldIds={paginatedMappings.map((field) => field.fieldName)}
          gridLayout={gridLayout}
          columns={FIELD_TABLE_COLUMNS_WITH_BULK_ACTIONS}
        />
        <TableBody
          currentCount={filteredMappings.length}
          emptyStateConfig={USER_FIELDS_EMPTY_STATE_CONFIG}
          hasError={isError}
          isLoading={isLoading}
          totalCount={mappings.length}
        >
          {paginatedMappings.map((field) => (
            <TableRow
              key={field.fieldName}
              field={field}
              fieldIds={selected.map((id) => id.toString())}
              gridLayout={gridLayout}
              objectFieldNames={objectMappingNames}
              onCreateNewField={onCreateNewField}
              onSelectRow={() => toggleSelection(field.fieldName)}
            />
          ))}
        </TableBody>
      </Table>
      <TablePagination numItems={filteredMappings.length} />
    </>
  );
};
